import { FC, memo, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { HubConnection, HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { ActivitiesActions } from 'Store/Activities/Activities.actions';
import { ITopicSignalRHasUpdate } from 'Data/interfaces/Activities/ITopicSignalRHasUpdate';

export interface ISignalRResponse {
  api?: string;
  fileIdentifier: string;
  progress: string;
  urn?: string;
  version?: undefined;
  timeStamp?: number;
}

export interface IActivitySignalR {
  csId: number;
}

const ActivitySignalR: FC<IActivitySignalR> = ({ csId }) => {
  const dispatch = useDispatch();

  const [connection, setConnection] = useState<HubConnection>();

  useEffect(() => {
    const newConnection = new HubConnectionBuilder()
      .withUrl(
        `${process.env.REACT_APP_BASE_API_URL?.toString().replace('/api', '')}/hubs/topics?csId=${csId}`,
      )
      .configureLogging(LogLevel.Information)
      .withAutomaticReconnect()
      .build();

    newConnection.serverTimeoutInMilliseconds = 100000;
    setConnection(newConnection);
  }, []);

  useEffect(() => {
    if (!connection) { return; }

    connection
      .start()
      .then((result) => {
        connection.on('hasUpdate', (data: string) => {
          const response = JSON.parse(data);
          const responseFormat: ITopicSignalRHasUpdate = {
            ...response,
            csId,
          };

          dispatch(ActivitiesActions.topicSignalRHasUpdate(responseFormat));
        });

        connection.on('TagValuesRemoved', (data: string) => {
          const response = JSON.parse(data);

          dispatch(ActivitiesActions.hasRemovedOptions(response));
        });
      })
      .catch((e) => {
        // console.log('Connection failed: ', e);
      });

    return () => {
      connection.stop();
    };
  }, [connection]);

  return <></>;
};

export default memo(ActivitySignalR, () => true);
